import { Button } from "@/components/ui/button";
import { Camera, Loader2, Upload } from "lucide-react";

interface VinUploadButtonsProps {
  processing: boolean;
  isLoading: boolean;
  onTakePhoto: () => void;
  onUploadImage: () => void;
}

export const VinUploadButtons = ({
  processing,
  isLoading,
  onTakePhoto,
  onUploadImage,
}: VinUploadButtonsProps) => {
  return (
    <div className="flex flex-col sm:flex-row gap-2 justify-center">
      <Button
        variant="outline"
        onClick={onTakePhoto}
        disabled={processing || isLoading}
        type="button"
      >
        {processing || isLoading ? (
          <Loader2 className="h-4 w-4 mr-2 animate-spin" />
        ) : (
          <Camera className="h-4 w-4 mr-2" />
        )}
        {processing ? "Processing..." : "Take Photo"}
      </Button>
      <Button
        variant="outline"
        onClick={onUploadImage}
        disabled={processing || isLoading}
        type="button"
      >
        {processing || isLoading ? (
          <Loader2 className="h-4 w-4 mr-2 animate-spin" />
        ) : (
          <Upload className="h-4 w-4 mr-2" />
        )}
        {processing ? "Processing..." : "Upload Image"}
      </Button>
    </div>
  );
};